<template>
  <v-container fluid class="paywall-list px-0">
    <div class="header">
      <div class="text-h5 pl-2">付费界面</div>
      <v-btn color="primary" @click="onCreate">创建界面</v-btn>
    </div>
    <v-list>
      <v-list-item-group color="primary">
        <v-list-item class="list-item" v-for="item in list" :key="item.id" @click="onClickItem(item.id)">
          <v-row class="paywall-row" align="center" justify="space-between">
            <v-col cols="5">{{ item.name }}</v-col>
            <v-col cols="4">共{{ item.product_id_s.length }}个商品</v-col>
            <v-col cols="3" class="text-right">
              <v-btn class="btn-preview" outlined small color="primary" @click.stop="onPreview(item)">预览</v-btn>
            </v-col>
          </v-row>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <PaywallPreviewDialog :url="previewUrl" v-model="showPreview" />
  </v-container>
</template>

<script>
import { customerStore } from '@/store/customer'
import { paywallStore } from '@/store/paywall'
import PaywallPreviewDialog from '@/views/product/PaywallPreviewDialog.vue'

export default {
  components: { PaywallPreviewDialog },
  data() {
    return {
      previewUrl: null,
      showPreview: false,
    }
  },
  computed: {
    list() {
      return paywallStore.list
    },
  },
  methods: {
    onCreate() {
      this.$router.push('/dash/paywall-detail')
    },
    onClickItem(id) {
      this.$router.push({
        path: '/dash/paywall-detail',
        query: { id },
      })
    },
    async onPreview(item) {
      let result = await customerStore.doPreviewHomeLink({
        paywall_id: item.id,
      })
      this.previewUrl = result.url
      this.showPreview = true
    },
  },
}
</script>

<style lang="less" scoped>
.paywall-list {
  .header {
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: space-between;
  }

  .btn-preview {
    position: relative;
    right: -8px;
  }
}
</style>
